import Button from "@src/components/Button/Button";
import { useNavigate } from "react-router";
import { useUserStore } from "@src/stores/userStore";
import "./styles/homepage.sass";
import Logo from "@src/components/Logo/Logo";
import { Link } from "react-router-dom";
import Page from "@src/layout/Page";
import { useGlobalSettings } from "@src/hooks/useGlobalSettings";
import { isTrue } from "@src/utils/string";
const Homepage = () => {
    const navigate = useNavigate();
    const isLoggedIn = useUserStore((state) => state.isLoggedIn);
    const globalSettings = useGlobalSettings();
    const { users_can_login = "true", users_can_register = "false", is_under_maintenance = "false" } = globalSettings || {};
    return (
        <Page>
            <div id="homepage">
                <header>
                    <h1>
                        <Logo size="l" />
                    </h1>
                    <p className="header__text">
                        Your over-engineered character reference sheet
                    </p>
                </header>
                {isTrue(is_under_maintenance) && (
                    <div className="banner banner--info">
                        <h2>!Under maintenance!</h2>
                        <p>Hey! I'm working on things in the background. To prevent any data loss or extreme frustration, the app has been placed under maintenance. Check socials or the admin message for more info</p>
                    </div>

                )}
                {!isLoggedIn && !isTrue(is_under_maintenance) && (
                    <div className="cta">
                        {isTrue(users_can_login) &&
                            <Button
                                preset="secondary"
                                fn={() => navigate("/login")}
                            >
                                Login
                            </Button>}
                        {isTrue(users_can_register) &&
                            <Button
                                preset="primary"
                                fn={() => navigate("/register")}
                            >
                                Create an account
                            </Button>
                        }
                    </div>
                )}
                {isLoggedIn ? (
                    <div className="nav">
                        <Button preset="stealth">
                            <Link to="/characters">Your characters</Link>
                        </Button>
                        <Button preset="stealth">
                            <Link to="/worlds">Your worlds</Link>
                        </Button>
                        <Button preset="stealth">
                            <Link to="/links">Your links</Link>
                        </Button>
                    </div>
                ) : null}
            </div>
        </Page>
    );
};
export default Homepage;
